module.exports = __webpack_public_path__ + "static/media/icon-plus.7c6c8212.svg";